import React, { useMemo } from 'react';
import ActionsMenu from '../../common/Navigation/ActionsMenu';
import ActionButton from '@severalnines/bar-frontend-components/build/lib/General/ActionButton';
import { SettingsIcon } from '../../common/icons/icons';
import CcCluster from '../../services/models/CcCluster';
import ButtonWithForm from '../../common/General/ButtonWithForm';
import ClusterEnablePrometheusButton from '../Clusters/Actions/ClusterEnablePrometheusButton';
import PrometheusExportersModal from '../Prometheus/PrometheusExportersModal';
import PrometheusConfigurationModal from '../Prometheus/PrometheusConfigurationModal';
import ClusterDisablePrometheusButton from '../Clusters/Actions/ClusterDisablePrometheusButton';
import { ActionMenuItem } from '@severalnines/bar-frontend-components/build/lib/Navigation/ActionMenu';
import {
    CloseCircleOutlined,
    PlayCircleOutlined,
    ProfileOutlined,
} from '@ant-design/icons';

export default MonitorSettingsMenu;

export type MonitorSettingsMenuProps = {
    cluster: CcCluster;
    extraItems?: React.ReactNode[];
};

function MonitorSettingsMenu({
    cluster,
    extraItems,
}: MonitorSettingsMenuProps) {
    const menuItems = useMemo(() => {
        const node = cluster.getPrometheusNode();
        let items: React.ReactNode[] = [
            {
                key: 'enable_monitoring',
                icon: <PlayCircleOutlined />,
                label: (
                    <ClusterEnablePrometheusButton
                        reEnable={!!node}
                        cluster={cluster}
                    />
                ),
            },
        ];
        if (node) {
            items.unshift(
                {
                    key: 'exporters',
                    icon: <ProfileOutlined />,
                    label: (
                        <ButtonWithForm
                            button={<ActionButton>Exporters</ActionButton>}
                            form={
                                <PrometheusExportersModal
                                    node={node}
                                    cluster={cluster}
                                />
                            }
                        />
                    ),
                },
                {
                    key: 'configuration',
                    icon: <SettingsIcon />,
                    label: (
                        <ButtonWithForm
                            button={<ActionButton>Configuration</ActionButton>}
                            form={
                                <PrometheusConfigurationModal
                                    cluster={cluster}
                                    node={node}
                                />
                            }
                        />
                    ),
                }
            );
        }
        if (extraItems && extraItems.length) {
            items = items.concat(extraItems);
        }
        if (node) {
            items.push({
                key: 'disable_monitoring',
                icon: <CloseCircleOutlined />,
                critical: true,
                label: <ClusterDisablePrometheusButton cluster={cluster} />,
            });
        }
        return items;
    }, [cluster, extraItems]);
    return (
        <ActionsMenu items={menuItems as ActionMenuItem[]}>
            <SettingsIcon />
        </ActionsMenu>
    );
}
